import { isNotDefined } from '@sgme/fp';
import { SeriesLineOptions } from 'highcharts';

import { Table } from './Graphs.model';

export function addConstant(name: string, value?: number, index?: string[]) {
  if (isNotDefined(value) || isNotDefined(index)) {
    return [];
  }

  const series = {
    type: 'line',
    name,
    data: [
      [index[0], value],
      [index[index.length - 1], value],
    ],
    tooltip: { valueDecimals: 2 },
  };
  return [series] as SeriesLineOptions[];
}

type SelectedColumn = { name: string; label: string; visible?: boolean };
export function addTable(table?: Table, index?: string[], selectedColumns: SelectedColumn[] = []): SeriesLineOptions[] {
  if (isNotDefined(table) || isNotDefined(index)) {
    return [];
  }

  return selectedColumns.map(({ name, label, visible }) => {
    const { rows, columns } = table;
    const firstRow = rows[0];
    const colIndex = columns.findIndex(col => col === name);

    if (colIndex === -1) {
      return { type: 'line', name };
    }

    return {
      type: 'line',
      name: label,
      visible,
      data: [
        [index[0], firstRow[colIndex]],
        [index[index.length - 1], firstRow[colIndex]],
      ],
      tooltip: { valueDecimals: 2 },
    } as SeriesLineOptions;
  });
}
